<style scoped>
    @import url("../../styles/aqua/aqua.scss");
</style>

<template>
    <div class="box_aqua">
        
        <div class="plantaPainel">

            <div class="setor1">
                <div class="race1">teste raceway</div>
            </div>

        </div>

    </div>
</template>

<script>
//import axios from 'axios'

export default {

    data() {
        return {
            //
            corCi:'blue',
        }
    },

    methods: {
        //
    },

    created() {
        //this.$store.commit('srcIPloja') // without param. Initial main GET Req.
        window.scrollTo(0,0)
    }
}
</script>